import type { Authen, UserProfile } from './type';

import { pick } from 'lodash';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { LOCAL_STORAGE_AUTH_KEY } from 'constants/local-storage';

import { defaultAuthen, defaultUserProfile } from './constant';

interface State {
  auth: Authen;
  userProfile: UserProfile;
}

interface Store {
  state: State;
  setState: (payload: Partial<State>) => void;
  updateAuthen: (payload: Authen) => void;
  clearState: () => void;
  updateUserProfile: (payload: UserProfile) => void;
  clearUserProfile: () => void;
}

const initState: State = {
  auth: defaultAuthen,
  userProfile: defaultUserProfile,
};

export const useAuthStore = create(
  persist(
    immer<Store>((set) => ({
      state: initState,
      setState: (payload) => {
        set((store) => {
          store.state = { ...store.state, ...payload };
        });
      },
      updateUserProfile: (payload) => {
        set((store) => {
          store.state.userProfile = payload;
        });
      },
      clearUserProfile: () => {
        set((store) => {
          store.state.userProfile = defaultUserProfile;
        });
      },
      updateAuthen: (payload) => {
        set((store) => {
          store.state.auth = payload;
        });
      },
      clearState: () => {
        set((store) => {
          store.state = initState;
        });
      },
    })),
    {
      name: LOCAL_STORAGE_AUTH_KEY,
      partialize: (store: Store) => ({
        state: pick(store.state, 'auth'),
      }),
    },
  ),
);

export const { updateUserProfile, clearUserProfile, setState, clearState, updateAuthen } =
  useAuthStore.getState();

export const authenSelector = (s: Store) => s.state.auth;

export const userProfileSelector = (s: Store) => s.state.userProfile;
